import { render, staticRenderFns } from "./FormInputCheckboxes.vue?vue&type=template&id=c05e225e&scoped=true"
import script from "./FormInputCheckboxes.vue?vue&type=script&lang=js"
export * from "./FormInputCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./FormInputCheckboxes.vue?vue&type=style&index=0&id=c05e225e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05e225e",
  null
  
)

export default component.exports